import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {BisherigeBetrieblicheVerhaeltnisseAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-bisherige-betriebliche-verhaeltnisse-angaben',
  templateUrl: './bisherige-betriebliche-verhaeltnisse-angaben.component.html'
})
export class BisherigeBetrieblicheVerhaeltnisseAngabenComponent
  extends WizardPageBaseComponent<BisherigeBetrieblicheVerhaeltnisseAngaben> {

  static nutzdatenPath = 'bisherigeBetrieblicheVerhaeltnisseAngaben';
  static route = 'bisherige-betriebliche-verhaeltnisse-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([]);
  }
}
